import React from "react";
var __jsx = React.createElement;
var NoSearchResultSVG = function NoSearchResultSVG(_ref) {
  var _ref$filledColor = _ref.filledColor,
    filledColor = _ref$filledColor === void 0 ? "#154F9C" : _ref$filledColor,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6938 0C30.5684 0 39.3974 8.78765 39.3974 19.6332C39.3974 22.5494 38.7611 25.3193 37.6159 27.8064L44.9473 34.1948C50.2916 39.6761 47.2866 44.4454 45.8673 45.8596C44.5459 47.2836 39.6127 50.2973 34.1607 44.9428L27.7005 37.5694C25.2535 38.652 22.5519 39.2567 19.7036 39.2567C8.81914 39.2567 0 30.469 0 19.6235C0 8.77789 8.80935 0 19.6938 0ZM37.0977 42.4168C38.0178 43.4311 40.6312 45.138 43 43.1288C43.6558 42.5729 44.987 39.7737 42.2854 37.2476L35.5022 31.3469C34.2983 32.9562 32.8594 34.3802 31.2248 35.5505L37.0977 42.4168ZM35.2764 19.6329C35.2764 28.206 28.2975 35.16 19.6937 35.16C11.0801 35.16 4.1109 28.206 4.1109 19.6329C4.1109 11.0598 11.0899 4.1058 19.6937 4.1058C28.2975 4.1058 35.2764 11.0598 35.2764 19.6329Z",
    fill: filledColor
  }));
};
export default NoSearchResultSVG;